




















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Confirm extends Vue {
    @Prop({default: ""}) private msg!: string;
    @Prop({default: false}) private show!: string;
    @Prop() private data!: {};
    private close(respond: boolean) {
        this.$emit('update:show', false);

        if (respond) {
            this.$emit('confirmed', this.data);
        }
    }
}
